import t, { memo as J, useState as $, useId as k } from "react";
import { Card as K, CardContent as Q } from "../../atoms/card/card.js";
import { useTheme as X, Flex as w, Box as Y, Heading as Z, Text as N, Collapse as tt, CloseButton as et } from "@chakra-ui/react";
import { IconReact as ot } from "../../atoms/icon/icon-react.js";
import { MdExpandMore as rt } from "@react-icons/all-files/md/MdExpandMore";
import { MdExpandLess as at } from "@react-icons/all-files/md/MdExpandLess";
import "react-icons/md";
import { Button as nt } from "../../atoms/button/button.js";
import "../../atoms/button/icon-button.js";
import "react-icons/fa";
import "../../atoms/button/masthead-button.js";
import { getFocusIndicator as lt } from "../../../utils/accessibilityUtils.js";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "../../atoms/button/close-button.js";
const kt = J(
  ({
    contentTitle: A,
    contentBody1: O,
    variantId: o,
    ctaText: c,
    contentBody2: n,
    materialIcon: l,
    hasCloseButton: z = !1
  }) => {
    var R, I;
    const {
      alertsBorderRadius: G,
      alertsTitle: W,
      alertsSubtext: s,
      alertBorder: r,
      alertsIconSize: e,
      alertsUnderline: _,
      alertsDetails: F,
      alertsInteriorSpacing: d,
      alertPadding: m,
      text: { default: i },
      interactive: { default: p },
      surface: { error: M, warning: B, success: D, info: H },
      element: { spacingMedium: u },
      content: { spacingLarge: L },
      icon: {
        error: f,
        warning: g,
        success: b,
        info: E,
        default: P
      }
    } = X(), [a, T] = $(!1), [U, v] = $(!0), y = a ? at : rt, C = {
      SUCCESS: {
        backgroundColor: D,
        border: `${r} solid ${b}`
      },
      ERROR: {
        backgroundColor: M,
        border: `${r} solid ${f}`
      },
      WARNING: {
        backgroundColor: B,
        border: `${r} solid ${g}`
      },
      INFO: {
        backgroundColor: H,
        border: `${r} solid ${E}`
      }
    }, h = {
      SUCCESS: {
        fill: b
      },
      ERROR: {
        fill: f
      },
      WARNING: {
        fill: g
      },
      INFO: {
        fill: E
      }
    }, V = lt(
      C[o].backgroundColor
    ), x = k(), S = k(), j = () => {
      v(!1);
    }, q = typeof l == "function" ? t.createElement(l, {
      size: e,
      color: ((R = h[o]) == null ? void 0 : R.fill) || "",
      "aria-hidden": !0,
      "data-testid": "alert-icon-function"
    }) : /* @__PURE__ */ t.createElement(
      ot,
      {
        iconName: l,
        iconProps: {
          size: e,
          color: ((I = h[o]) == null ? void 0 : I.fill) || "",
          "data-testid": "alert-icon-string"
        }
      }
    );
    return U && /* @__PURE__ */ t.createElement(
      K,
      {
        position: "relative",
        variant: "horizontal",
        borderRadius: G,
        sx: C[o],
        padding: m,
        tabIndex: n ? null : -1
      },
      /* @__PURE__ */ t.createElement(Q, null, /* @__PURE__ */ t.createElement(w, { columnGap: d }, /* @__PURE__ */ t.createElement(Y, null, q), /* @__PURE__ */ t.createElement(
        w,
        {
          flexDirection: "column",
          rowGap: d,
          sx: { ".chakra-collapse": { rowGap: 0 } },
          paddingRight: L
        },
        /* @__PURE__ */ t.createElement(
          Z,
          {
            "data-testid": "alert-title",
            as: "h2",
            color: i,
            ...W
          },
          A
        ),
        /* @__PURE__ */ t.createElement(
          N,
          {
            color: i,
            "data-testid": "alert-content",
            ...s
          },
          O
        ),
        n && c && /* @__PURE__ */ t.createElement(
          nt,
          {
            id: `alert-button-${S}`,
            "data-testid": "alert-collapse-expand-button",
            rightIcon: /* @__PURE__ */ t.createElement(
              y,
              {
                size: e,
                color: p
              }
            ),
            color: p,
            onClick: () => T(!a),
            variant: "transparent",
            textDecoration: _,
            _focusVisible: V,
            "aria-expanded": a,
            "aria-controls": `alert-details-${x}`,
            padding: 0,
            maxW: "fit-content",
            minH: 0,
            sx: {
              ".chakra-button__icon": {
                marginLeft: 0
              }
            },
            ...F
          },
          c
        ),
        /* @__PURE__ */ t.createElement(tt, { in: a, startingHeight: 0 }, /* @__PURE__ */ t.createElement(
          N,
          {
            id: `alert-details-${x}`,
            color: i,
            "data-testid": "alert-content-details",
            "aria-labelledby": `alert-button-${S}`,
            ...s
          },
          n
        ))
      ), z && /* @__PURE__ */ t.createElement(
        et,
        {
          position: "absolute",
          right: u,
          top: u,
          color: P,
          width: e,
          height: e,
          padding: m,
          onClick: j,
          "data-testid": "alert-close-button"
        }
      )))
    );
  }
);
export {
  kt as Alert
};
